//global_reducer.js

// Production url
const targetIp = "https://api-pos.hulmsolutions.com";


// Local Url
//const targetIp = "http://192.168.100.123:8080";
// const targetIp = "http://192.168.100.119:8080";
// const targetIp = "http://192.168.100.21:8080";
// const targetIp = "http://192.168.100.65:8080";
// const targetIp = "http://192.168.100.72:8080";
// const targetIp = "http://127.0.0.1:8080";


const initial_state = {
  targetIp: `${targetIp}/POS`,
  // FOR KUBE
  //  targetIp: `${targetIp}`,
  ip: `${targetIp}/POS`,

  // FOR KUBE
  // ip: `${targetIp}`,
  userManagement: `http://${targetIp}:9084/UserManagement/HULM/cd28202b-371c-40d6-a40b-563c662591e5/`,
  companyName: "",
  instanceId: "",
  basePath: "",
  appType: "",
  appPath: "",
  //Local gateway url
  // gatewayUrl: "http://192.168.100.65:5003",
  // gatewayUrl: `http://192.168.100.21:5003`,
  //gatewayUrl: "http://192.168.100.123:5003",

  // gatewayUrl: "http://127.0.0.1:5003",

  //Production gateway url
  gatewayUrl: "https://api.hulmsolutions.com",

  zatcaUrl: "https://api-pos.hulmsolutions.com/api/fatoora",


  temp: `http://${targetIp}:9086/ViewsService/Views/bucket2/sputnik.hpos.e2a2e917-168e-4d1e-8ff5-81b2628b68e4/image.png`,
  imageUrl: `http://${targetIp}:9086/ViewsService/Views/bucket2/`,
  keyCloakAuth: `http://139.59.8.119:8070/auth/`,
  // keyCloakAuth: `https://keycloak.hulmsolutions.com/auth/`,
  KeycloakApi: "http://192.168.100.72:8084/api/keycloak",
  isAuthenticated: false,
  keycloakinstance: null,
  mediaBaseUrl: `https://s3.hulmsolutions.com/upload`,
  bussinessType: "",
};

const globalReducer = (state = initial_state, action) => {
  switch (action.type) {
    case "GET_BASE_URL": {
      const companyName = action.payload?.companyName || state.companyName;
      const instanceId = action.payload?.instanceId || state.instanceId;
      const appType = action.payload?.appType || state.appType;

      // Normalize slashes and construct path
      const cleanIp = state.ip.endsWith('/') ? state.ip.slice(0, -1) : state.ip;

      // Construct basePath ONLY if we have minimum required info
      let basePath = state.basePath;
      if (companyName && instanceId) {
        basePath = `${cleanIp}/${companyName}/${instanceId}`;
      }

      return {
        ...state,
        basePath: basePath,
        companyName: companyName,
        instanceId: instanceId,
        appType: appType,
      };
    }

    case "GET_GLOBAL_URL":
      return state;

    case "SETTING_AUTHENTICATION":
      return {
        ...state,
        isAuthenticated: action.payload?.isAuthenticated,
        keycloakinstance: action.payload?.keycloakinstance,
      };

    case "BUSSINESS_TYPE":
      return {
        ...state,
        bussinessType: action.payload?.bussinessType,
      };

    case "GLOBAL_RESET":
      return {
        ...state,
        instanceId: "",
        appType: "",
        companyName: "",
        bussinessType: "",
        basePath: "",
        isAuthenticated: false,
        keycloakinstance: null,
      };

    default:
      return state;
  }
};


export default globalReducer;
